import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import DashboardLayout from "../../Layouts/Layoutcontainers";
import EnhancedTable from "../../components/BTTable";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Card,
  FormControlLabel,
  Switch,
  Autocomplete,
  TextField,
  Tooltip,
} from "@mui/material";
import BTInput from "../../components/BTInput";
import BTButton from "../../components/BTButton";
import BTBox from "../../components/BTBox";
import AddCreditnote from "./AddCreditnote";
import { get } from "../../store/labSlice";
import { get_parties, get_sizes, get_cnv_rates } from "../../store/functions";
import { fetchData } from "../../utils/fetchData";
import { PictureAsPdf, Edit, Delete, Error } from "@mui/icons-material";
import { useLoading, useNotification } from "../../context";
import { batchUpdate } from "../../store/labSlice";
import secureLocalStorage from "react-secure-storage";
import authService from "../../services/auth-service";
import InvoicePDF from "./reports";
import { pdf } from "@react-pdf/renderer";
const default_search = {
  type: 1,
  p_id: null,
  from_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
  to_date: moment().add(1).format("YYYY-MM-DD"),
  rowsPerPage: 50,
  page: 1,
  searchText: null,
  last_id: 0,
  p_cn_id: null,
};

const CardHeader = ({
  search,
  setSearch,
  parties,
  tableType,
  setTableType,
  clearState,
  setOpenModal,
}) => {
  const [localDates, setLocalDates] = useState({
    from_date: search?.from_date || "",
    to_date: search?.to_date || "",
  });
  const handleDateChange = (field, value) => {
    const newDates = { ...localDates, [field]: value };
    setLocalDates(newDates);
    const timer = setTimeout(() => {
      clearState();
      setSearch({
        ...search,
        from_date: newDates.from_date,
        to_date: newDates.to_date,
        page: 1,
      });
    }, 500);

    return () => clearTimeout(timer);
  };

  return (
    <Card sx={{ mb: 1 }}>
      <BTBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}
      >
        <BTBox
          display="flex"
          alignItems="center"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={tableType}
                onChange={() => {
                  clearState();
                  setTableType(!tableType);
                  setSearch({
                    ...default_search,
                    type: tableType ? 1 : 2,
                  });
                }}
                size="small"
                color="secondary"
              />
            }
            label={"All records"}
            labelPlacement="end"
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          />

          <BTInput
            size="small"
            type="date"
            label="From Date"
            value={localDates.from_date}
            onChange={(e) => handleDateChange("from_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />

          <BTInput
            size="small"
            type="date"
            label="To Date"
            value={localDates.to_date}
            onChange={(e) => handleDateChange("to_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />
          <Autocomplete
            options={parties || []}
            getOptionLabel={(option) =>
              `${option.p_code} : ${option.p_name}` || ""
            }
            renderOption={(props, option) => (
              <li {...props}>{`${option.p_code} : ${option.p_name}`}</li>
            )}
            onChange={(event, value) => {
              clearState();
              setSearch({ ...search, p_id: value?.p_id, page: 1 });
            }}
            sx={{ width: "100%" }}
            value={parties?.find(({ p_id }) => p_id === search?.p_id) || null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Party"
                size="small"
                variant="standard"
                sx={{ width: { xs: "100%", sm: "200px" } }}
              />
            )}
          />
        </BTBox>
        <BTBox>
          <BTButton
            variant="gradient"
            size="small"
            fullWidth
            color="dark"
            onClick={() =>
              setOpenModal((prev) => ({
                ...prev,
                open_credit: { show: true, actionType: 1 },
              }))
            }
            // onClick={() => setOpen({ show: true, actionType: 1 })}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            Add Credit Note
          </BTButton>
        </BTBox>
      </BTBox>
    </Card>
  );
};
const ExpandComponent = ({ row, expandColumns, creditnote }) => {
  const [subRecords, setSubRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState({
    type: 2,
    p_id: null,
    from_date: null,
    to_date: null,
    rowsPerPage: 50000000000,
    page: 1,
    searchText: null,
    last_id: 0,
    p_cn_id: row?.cn_id,
  });

  useEffect(() => {
    const localSubs = creditnote?.filter(
      ({ p_cn_id, cn_type }) => cn_type === 2 && p_cn_id === row?.cn_id
    );
    if (localSubs > 0) {
      setSubRecords(localSubs);
    } else {
      fetchSubs();
    }
  }, []);

  const fetchSubs = async () => {
    try {
      const response = await fetchData({
        api: "get_credit_notes",
        name: "creditnote",
        key: "cn_id",
        searchParams: search,
        filterCallback: null,
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
        hold: false,
      });

      if (response?.status) {
        setSubRecords(response?.data);
      }
    } finally {
    }
  };



  return (
    <EnhancedTable
      loading={loading}
      rows={subRecords}
      columns={expandColumns}
      tableHeader={false}
    />
  );
};
const CreditNote = () => {
  const userdata = secureLocalStorage.getItem("userdata");
  const gst_number = userdata?.u_profile?.cmp_gst?.slice(0, 2);
  const [openModal, setOpenModal] = useState({
    open_credit: null,
  });
  const [search, setSearch] = useState(default_search);
  const [tableType, setTableType] = useState(false);
  const [loading, setLoading] = useState(false);
  const parties = useSelector((state) => state?.lab?.parties);
  const sizes = useSelector((state) => state?.lab?.sizes);
  const conversionRate = useSelector((state) => state?.lab?.conversionRate);
  const creditnote = useSelector((state) => state?.lab?.creditnote);
  let pageIndex = creditnote?.pages?.findIndex((p) => p.page === search.page);
  const startIndex = pageIndex !== -1 ? pageIndex * search.rowsPerPage : 0;
  const endIndex = startIndex + search.rowsPerPage;
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();
  const todayDate = moment().format("YYYY-MM-DD");
  const todayRate =
    conversionRate?.data?.find(
      (rate) => moment(rate.cnv_date).format("YYYY-MM-DD") === todayDate
    )?.cnv_rate || 0;

  useEffect(() => {
    !parties?.is_fetch && get_parties();
    !sizes?.is_fetch && get_sizes();
    !conversionRate?.is_fetch && get_cnv_rates();
    fetchCreditNote();
  }, [search]);
  const clearState = () => {
    dispatch(
      get({
        name: "creditnote",
        data: [],
        pages: [],
        total: 0,
        fetch: false,
      })
    );
  };
  const handleSearch = (data, searchData) => {
    const filterBySearch = data?.filter((item) => {
      const searchText = searchData?.searchText?.toLowerCase().trim() || "";
      const matchFilters =
        item?.cn_type === searchData?.type &&
        (searchData?.p_id ? item?.p_id === searchData?.p_id : true) &&
        moment(item.cn_date, "YYYY-MM-DD").isBetween(
          moment(searchData?.from_date, "YYYY-MM-DD").startOf("day"),
          moment(searchData?.to_date, "YYYY-MM-DD").endOf("day"),
          null,
          "[]"
        );
      return matchFilters;
    });

    const paginateData = filterBySearch?.slice(startIndex, endIndex);
    return paginateData;
  };
  const fetchCreditNote = async () => {
    await fetchData({
      api: "get_credit_notes",
      name: "creditnote",
      key: "cn_id",
      searchParams: search,
      filterCallback: handleSearch,
      showLoading: () => setLoading(true),
      hideLoading: () => setLoading(false),
      hold: true,
    });
  };
  const handleEdit = async (row) => {
    const { cn_id } = row || {};
    const response = await fetchData({
      api: "get_credit_notes",
      name: "creditnote",
      key: "cn_id",
      searchParams: {
        ...default_search,
        rowsPerPage: 5000000,
        page: 1,
        p_cn_id: cn_id,
      },
      filterCallback: null,
      showLoading,
      hideLoading,
      hold: false,
    });
    if (!response?.status) {
      addNotification({
        message:
          response?.message ||
          "Failed to connect to server. Please try again later.",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } else {
      setOpenModal((prev) => ({
        ...prev,
        open_credit: {
          actionType: 2,
          values: {
            ...row,
            sub_cn_lines: response?.data,
          },
        },
      }));
    }
  };
  const deleteCrediNote = async (row) => {
    const { cn_id } = row || {};
    const response = await fetchData({
      api: "get_credit_notes",
      name: "creditnote",
      key: "cn_id",
      searchParams: {
        ...default_search,
        rowsPerPage: 5000000,
        page: 1,
        p_cn_id: cn_id,
      },
      filterCallback: null,
      showLoading,
      hideLoading,
      hold: false,
    });
    if (!response?.status) {
      addNotification({
        message:
          response?.message ||
          "Failed to connect to server. Please try again later.",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } else {
      let creditNoteData = {
        ...row,
        sub_cn_lines: response?.data,
      };


      Swal.fire({
        title: "Are You Sure?",
        icon: "error",
        showCancelButton: true,
        button: {
          text: "Confirm!",
          closeModal: false,
          color: "info",
        },
        zIndex: "100000000",
      }).then(async (res) => {
        if (res?.isConfirmed) {
          const myData = {
            attributes: creditNoteData,
          };
          try {
            let response = await authService?.delete_credit_note(myData);
            if (response?.status) {
              dispatch(
                batchUpdate({
                  name: "creditnote",
                  key: "cn_id",
                  insert: [],
                  updateItems: [],
                  removeItems: [row, creditNoteData?.sub_cn_lines],
                })
              );
            }
          } catch (res) {
            addNotification({
              title: "#Error",
              message: res?.message || "Something went to wrong",
              color: "error",
              icon: <Error color="white" size="small" />,
            });
          }
        }
      });
    }
  };

  const handleDownloadJson = async (e, data) => {


    const asNumber = (v, fallback = null) => {
      if (v === null || v === undefined || v === "") return fallback;
      const n = Number(v);
      return Number.isFinite(n) ? n : fallback;
    };

    // helper: round to 2 decimals and return Number (not string)
    const round2 = (n) => {
      return asNumber(Number(Math.round((n + Number.EPSILON) * 100) / 100), 0);
    };

    // derive state code from GSTIN (first two chars) if available
    const getStateCodeFromGstin = (gstin) => {
      if (!gstin || typeof gstin !== "string") return null;
      const sc = gstin.substring(0, 2);
      return /^\d{2}$/.test(sc) ? sc : null;
    };

    const template = {
      Version: "1.1",
      TranDtls: {
        TaxSch: "GST",
        SupTyp: "B2B",
        IgstOnIntra: "N",
        RegRev: null,
        EcmGstin: null,
      },
      DocDtls: {
        Typ: "INV",
        No: "I1476/25-26",
        Dt: "25/07/2025",
      },
      SellerDtls: {
        Gstin: userdata?.u_profile?.cmp_gst || null,
        LglNm: userdata?.u_profile?.cmp_name || null,
        TrdNm: null,
        Addr1: userdata?.u_profile?.cmp_addr_line1 || null,
        Addr2: userdata?.u_profile?.cmp_addr_line2 || null,
        Loc: userdata?.u_profile?.cmp_city || null,
        Pin: asNumber(userdata?.u_profile?.cmp_pincode, null),
        Stcd: getStateCodeFromGstin(userdata?.u_profile?.cmp_gst),
        Ph: userdata?.u_profile?.cmp_ph || null,
        Em: userdata?.u_profile?.cmp_email || null,
      },
      BuyerDtls: {
        Gstin: null,
        LglNm: null,
        TrdNm: null,
        Pos: "24",
        Addr1: null,
        Addr2: null,
        Loc: null,
        Pin: null,
        Stcd: null,
        Ph: null,
        Em: null,
      },
      DispDtls: null,
      ValDtls: {
        AssVal: 0,
        IgstVal: 0,
        CgstVal: 0,
        SgstVal: 0,
        CesVal: 0,
        StCesVal: 0,
        Discount: 0,
        OthChrg: 0,
        RndOffAmt: 0,
        TotInvVal: 0,
      },
      ItemList: [
        {
          SlNo: "1",
          PrdDesc: "Certificate Charges",
          IsServc: "Y",
          HsnCd: "998346",
          Qty: 1,
          Unit: "PCS",
          UnitPrice: 0,
          TotAmt: 0,
          Discount: 0,
          PreTaxVal: 0,
          AssAmt: 0,
          GstRt: 18,
          IgstAmt: 0,
          CgstAmt: 0,
          SgstAmt: 0,
          CesRt: 0,
          CesAmt: 0,
          CesNonAdvlAmt: 0,
          StateCesRt: 0,
          StateCesAmt: 0,
          StateCesNonAdvlAmt: 0,
          OthChrg: 0,
          TotItemVal: 0,
        },
      ],
    };
    const jsonformateData = data?.map((item, index) => {
   

      const cnTotal = asNumber(item?.cn_total, 0);

      const gstRate = asNumber(
        item?.cn_gst_rate ?? userdata?.u_profile?.cmp_gst_rate,
        asNumber(userdata?.u_profile?.cmp_gst_rate, 18)
      );

      // seller and buyer state codes
      const sellerState =
        template.SellerDtls.Stcd ||
        getStateCodeFromGstin(template.SellerDtls.Gstin);
      const buyerState =
        item?.p_org_state_code ||
        getStateCodeFromGstin(item?.p_org_gst) ||
        null;

      // tax calc (rounded to 2 decimals)
      const rawTax = (cnTotal * Number(gstRate)) / 100;
      const tax = round2(rawTax);

      let igst = 0,
        cgst = 0,
        sgst = 0;
      if (sellerState && buyerState && sellerState === buyerState) {
        // intra-state: split into CGST & SGST equally
        cgst = round2(tax / 2);
        sgst = round2(tax / 2);
        // adjust for rounding differences to make sum exactly = tax
        // const sumCgSg = round2(cgst + sgst);
        // if (sumCgSg !== tax) {
        //   // adjust cgst to absorb difference
        //   cgst = round2(cgst + (tax - sumCgSg));
        // }
      } else {
        // inter-state: IGST only
        igst = tax;
      }

      const totInvVal = Math.round(cnTotal + tax);
      const unitPrice = round2(cnTotal);
      const totItemVal = totInvVal; // single-line invoice assumption

      // phone handling (avoid "null/null" or "undefined/..." strings)
      const phone1 = item?.p_org_mo_no_1 || null;
      const phone2 = item?.p_org_mo_no_2 || null;
      let phoneConcat = null;
      if (phone1 && phone2) phoneConcat = `${phone1}/${phone2}`;
      else if (phone1) phoneConcat = phone1;
      else if (phone2) phoneConcat = phone2;
      else phoneConcat = null;

      // pin handling: keep number if available else null
      const buyerPin = asNumber(item?.p_org_pincode, null);

      return {
        ...template,
        DocDtls: {
          ...template.DocDtls,
          No: item?.cn_invoice || template.DocDtls.No,
          Dt: item?.cn_date
            ? moment(item?.cn_date).format("DD/MM/YYYY")
            : template.DocDtls.Dt,
        },
        SellerDtls: {
          ...template.SellerDtls,
          // keep existing seller info from userdata (already set in template)
          // ensure Pin is numeric or null
          Pin: asNumber(
            userdata?.u_profile?.cmp_pincode,
            template.SellerDtls.Pin
          ),
        },
        BuyerDtls: {
          ...template.BuyerDtls,
          Gstin: item?.p_org_gst || null,
          LglNm: item?.p_org_name || null,
          Addr1: item?.p_org_address_line1 || null,
          Addr2: item?.p_org_address_line2 || null,
          Pin: buyerPin,
          Ph: phoneConcat,
          Em: item?.p_org_email || null,
          Loc: item?.p_address || null,
          Stcd: buyerState,
          Pos: buyerState || template.BuyerDtls.Pos,
        },
        ValDtls: {
          ...template.ValDtls,
          AssVal: round2(cnTotal),
          IgstVal: round2(igst),
          CgstVal: round2(cgst),
          SgstVal: round2(sgst),
          TotInvVal: totInvVal,
        },
        ItemList: [
          {
            ...template.ItemList[0],
            SlNo: String(index + 1),
            UnitPrice: unitPrice,
            TotAmt: round2(cnTotal),
            AssAmt: round2(cnTotal),
            GstRt: gstRate,
            IgstAmt: round2(igst),
            CgstAmt: round2(cgst),
            SgstAmt: round2(sgst),
            TotItemVal: totItemVal,
          },
        ],
      };
    });

    const jsonString = JSON.stringify(jsonformateData, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "example.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  const handleDownloadPDF = async (row) => {
    const { cn_id } = row || {};
    const response = await fetchData({
      api: "get_credit_notes",
      name: "creditnote",
      key: "cn_id",
      searchParams: {
        ...default_search,
        rowsPerPage: 5000000,
        page: 1,
        p_cn_id: cn_id,
      },
      filterCallback: null,
      showLoading,
      hideLoading,
      hold: false,
    });
    if (!response?.status) {
      addNotification({
        message:
          response?.message ||
          "Failed to connect to server. Please try again later.",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } else {
      let cnData = {
        ...row,
        sub_cn_lines: response?.data,
      };
      const blob = await pdf(
        <InvoicePDF data={cnData} sizes={sizes} loginuser={userdata} />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const newTab = window.open(url, "_blank");
      newTab.document.close();
      newTab.onbeforeunload = () => {
        URL.revokeObjectURL(url);
      };
    }
  };

  const expandColumns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "cn_invoice",
      name: "Invoice No.",
      selector: (row) => row?.cn_invoice,
      sortable: true,
    },
    {
      id: "p_id",
      name: "Party",
      selector: (row) =>
        parties?.data?.find(({ p_id }) => p_id === row?.p_id)?.p_name,
      sortable: true,
    },
    {
      id: "ser_name",
      name: "Service",
      selector: (row) => row.ser_name || "-",
      sortable: true,
    },
    {
      id: "size_id",
      name: "Size",
      selector: (row) => {
        return "-";
      },
      sortable: true,
    },
    {
      id: "cn_pcs",
      name: "Pcs",
      selector: (row) => row?.cn_pcs || "-",
      sortable: true,
    },
    {
      id: "cn_date",
      name: "Date",
      selector: (row) => moment(row?.cn_date).format("DD/MM/YYYY"),
      width: "150px",
      sortable: true,
    },
    {
      id: "cn_cts",
      name: "Weight",
      selector: (row) => row.cn_cts || "-",
      sortable: true,
    },
    {
      id: "cn_rate",
      name: "Rate",
      selector: (row) => row?.cn_rate,
      sortable: true,
    },
    {
      id: "cn_amount",
      name: "Amount",
      selector: (row) => row?.cn_amount || "-",
      sortable: true,
    },
    {
      id: "cn_total",
      name: "Total",
      selector: (row) => row?.cn_total || "-",
      sortable: true,
    },
    {
      id: "cn_desc",
      name: "Description",
      selector: (row) => row?.cn_desc,
    },
    {
      id: "actions",
      name: "Actions",
      selector: (row) => (
        <BTBox>
          {row?.cn_status === 1 && (
            <Tooltip title="delete">
              <Delete
                sx={{
                  cursor: "pointer",
                  color: "error.main",
                  fontSize: "18px",
                }}
                onClick={async () => {
                  deleteCrediNote(row);
                }}
              />
            </Tooltip>
          )}
        </BTBox>
      ),
    },
  ];
  const columns = [
    {
      id: "id",
      name: "ID",
      value: (row) => row?.cn_id,
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "cn_invoice",
      name: "Invoice No.",
      selector: (row) => row?.cn_invoice,
      sortable: true,
    },
    {
      id: "p_id",
      name: "Customer",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_name;
      },
      sortable: true,
    },
    {
      id: "p_org_gst",
      name: "GST No.",
      selector: (row) => {
        return row?.p_org_gst || "-";
      },
    },
    {
      id: "p_org_state",
      name: "State",
      selector: (row) => row?.p_org_state,
      sortable: true,
    },
    {
      id: "p_org_pincode",
      name: "ZIP Code",
      selector: (row) => row?.p_org_pincode || "-",
      sortable: true,
    },
    {
      id: "cn_date",
      name: "Date",
      selector: (row) =>
        moment(row?.cn_date, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY"),
      width: "150px",
      sortable: true,
    },
    {
      id: "cn_pcs",
      name: "Pcs",
      selector: (row) => row?.cn_pcs || "-",
      width: "150px",
      sortable: true,
    },
    {
      id: "cn_cts",
      name: "Weight",
      selector: (row) => row?.cn_cts || "-",
      width: "150px",
      sortable: true,
    },
    {
      id: "cn_amount",
      name: "Gross Amount($)",
      selector: (row) => row?.cn_amount || "-",
      sortable: true,
      type: "number",
    },
    {
      id: "cn_total",
      name: "Gross Total",
      selector: (row) => row.cn_total || "-",
      sortable: true,
      type: "number",
    },
    {
      id: "cn_cgst",
      name: "CGST",
      selector: (row) => {
        const startsWith24 = row?.p_org_gst?.startsWith(gst_number);
        return startsWith24 ? Number(row?.cn_cgst)?.toFixed(2) : "-";
      },
      type: "number",
      sortable: true,
    },
    {
      id: "cn_sgst",
      name: "SGST",
      selector: (row) => {
        const startsWith24 = row?.p_org_gst?.startsWith(gst_number);
        return startsWith24 ? Number(row?.cn_sgst)?.toFixed(2) : "-";
      },
      type: "number",
      sortable: true,
    },
    {
      id: "cn_igst",
      name: "IGST",
      selector: (row) => {
        const startsWith24 = row?.p_org_gst?.startsWith(gst_number);
        return !startsWith24 ? Number(row?.cn_igst)?.toFixed(2) : "-";
      },
      type: "number",
      sortable: true,
    },
    {
      id: "cn_net_amount",
      name: "Net Amount",
      selector: (row) => Number(row?.cn_net_amount)?.toFixed(2) || "-",
      sortable: true,
      type: "number",
    },
    {
      id: "actions",
      name: "Action",
      width: "200px",
      value: () => "",
      selector: (row) => {
        return (
          <BTBox display="flex" flexDirection={"row"} gap={1}>
            <Tooltip title="download bill">
              <PictureAsPdf
                sx={{
                  cursor: "pointer",
                  fontSize: "20px",
                }}
                onClick={() => handleDownloadPDF(row)}
              />
            </Tooltip>
            {row?.cn_status === 1 && (
              <Tooltip title={"Edit"}>
                <Edit
                  sx={{
                    cursor: "pointer",
                    color: "secondary.main",
                    fontSize: "18px",
                  }}
                  onClick={() => handleEdit(row)}
                />
              </Tooltip>
            )}
            {row?.cn_status === 1 && (
              <Tooltip title="delete">
                <Delete
                  sx={{
                    cursor: "pointer",
                    color: "error.main",
                    fontSize: "18px",
                  }}
                  onClick={async () => {
                    deleteCrediNote(row);
                  }}
                />
              </Tooltip>
            )}
          </BTBox>
        );
      },
    },
  ];
  const renderData = creditnote?.data?.filter(
    ({ cn_type }) => cn_type === search?.type
  );

  return (
    <DashboardLayout>
      <CardHeader
        search={search}
        setSearch={setSearch}
        parties={parties?.data}
        setLoading={setLoading}
        tableType={tableType}
        setTableType={setTableType}
        clearState={clearState}
        setOpenModal={setOpenModal}
      />
      <BTBox mt={4}>
        <EnhancedTable
          columns={tableType ? expandColumns : columns}
          loading={loading}
          tableHeader={true}
          rows={renderData?.slice(startIndex, endIndex)}
          title="Credit Notes"
          defaultSort="carbs"
          pagination={true}
          expandComponent={
            <ExpandComponent
              expandColumns={expandColumns}
              creditnote={creditnote?.data}
            />
          }
          expandRow={tableType ? false : true}
          checkBoxSelected={true}
          fetchData={{
            fnc: fetchData,
            params: {
              api: "get_credit_notes",
              searchParams: {
                ...search,
                page: 1,
                rowsPerPage: creditnote?.total,
              },
              filterCallback: null,
              name: "creditnote",
              key: "cn_id",
              showLoading,
              hideLoading,
              hold: false,
            },
          }}
          selectedConfiguration={{
            bgColor: "white",
            buttons: [
              <BTButton
                color={"dark"}
                variant={"gradient"}
                size="small"
                onClick={handleDownloadJson}
                fullWidth
                sx={{ width: "150px" }}
              >
                export json
              </BTButton>,
            ],
          }}
          serverSidePagination={true}
          serverSideSearch={true}
          totalRows={creditnote.total}
          onPageChange={({ page, rowsPerPage, searchText }) => {
            if (search?.rowsPerPage !== rowsPerPage) {
              clearState();
            }
            setSearch({
              ...search,
              page,
              rowsPerPage,
              searchText,
              last_id: creditnote?.pages[pageIndex]?.next_last_id,
            });
          }}
          onSearchChange={(searchText, { page, rowsPerPage }) => {
            clearState();
            setSearch((prev) => ({ ...prev, searchText, page, rowsPerPage }));
          }}
          initialPage={search?.page}
          getRowStyle={(row) => {
            if (row?.cn_status === 2) {
              return {
                backgroundColor: "#f8c1bfff",
                "&:hover": {
                  backgroundColor: "#ffffffff",
                },
              };
            }
          }}
        />
      </BTBox>
      {Boolean(openModal?.open_credit) && (
        <AddCreditnote
          open={openModal}
          setOpen={setOpenModal}
          type={tableType}
          todayRate={todayRate}
        />
      )}
    </DashboardLayout>
  );
};
export default CreditNote;
